import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';
import { Service } from '../network.service';
let $ = require('jquery');
import { AppState } from '../../../app.service';
import { NgForm } from '@angular/forms';
import { ConnectGatewayWizard } from './wizards/connect-gateway/connect-gateway.wizard';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../refresh-shared-service';
const _ = require('lodash');


@Component({
  selector: 'direct-connect-detail',
  styles: [require('./direct-connect.scss')],
  template: require('./direct-connect.html'),
  providers: [
    Service, TranslateService
  ],
})

export class DirectConnectDetail {
    private dcList: any;
    private dcProcessedData: Array<any> = [];
    private isTranslationready:boolean = true;
    private subscribeHandler;
    private isConnectGatewayWizardVisible: boolean = false;
    private directConnectName: string = "";
    private createData: any;
    private rowData: any;
    private editData: any;
    private isEditNetwork: any;
    private isEdit: boolean = false;
    private isDisconnectGatewayVisible: boolean = false;
    private isConnectNetworkVisible: boolean = false;
    private isEditGatewayWizardVisible: boolean = false;
    private loaded: boolean = false;
    private cardClass: string = 'direct-connect-details';
    private currentClassName: string = '';
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;

    constructor(public appState: AppState,
                public service: Service,
                private translate: TranslateService,
                private route: ActivatedRoute,
                private rss: RefreshSharedService) {
        translate.use(GlobalVariables.LOCALE);
        this.loaded = false;
        this.rsService = rss;
        this.currentClassName = 'DirectConnectDetail';
    }

    ngOnInit() {
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
            item => {
            this.handleEmittedValues(item);
        });

        this.route.params.forEach((params: Params) => {
            this.directConnectName = params['name'];
            this.rsService.setParam({
                'loadedComponent': this.currentClassName,
                'detailPageIDName': params['name'],
                'shouldReloadInventoryTree': true
            })
            this.dcList = [];
            this.dcProcessedData = []
            this.getDirectConnect(this.directConnectName);
        });
    }

    handleEmittedValues(item) {
        if (item.loadedComponent === this.currentClassName) {
            this.dcList = [];
            this.dcProcessedData = []
            this.getDirectConnect(this.directConnectName);
        }
    }

    getDirectConnect(dcName: string) {
        this.dcProcessedData = [];
        this.loaded = false;
        this.subscribeHandler = this.service.getDirectConnect()
        .subscribe(
            (dcList: any) => {
            this.dcList = [];
            for (let i = 0; i < dcList.directConnects.length; i++) {
                if (dcList.directConnects[i].directConnectConfiguration.name == dcName) {
                    this.dcList = [dcList.directConnects[i]];
                    break;
                }
            }
            this.dcProcessedData = this.service.processData(this.dcList);
            this.loaded = true;

            },
            error => this.service.logError(error, 'get Direct Connect error'),
            () => this.service.logOperationCompleted('get Direct Connect Completed')
        );
    }

    showConnectGatewayWizard(rowData: any) {
        this.createData = _.cloneDeep(rowData);
        this.isConnectGatewayWizardVisible = true;
    }

    wizStatusChange(event) {
        this.isConnectGatewayWizardVisible = event;
    }

    showEditNetworkDialog(rowData: any, subnet: any, directConnectName: string) {
        this.createData = {
                'rowData': _.cloneDeep(rowData),
                'subnet': _.cloneDeep(subnet),
                'directConnectName': directConnectName
            };
        this.directConnectName = directConnectName;
        this.isConnectNetworkVisible = true;
        this.isEditNetwork = true;
    }

    showEditGatewayWizard(rowData: any, edge: any) {
        this.editData = {rowData: _.cloneDeep(rowData), edge: _.cloneDeep(edge)};
        this.isEditGatewayWizardVisible = true;
    }

    showDisconnectGatewayDialog(rowData: any, edge: any, directConnectName: string, edgeName: string) {
        this.createData = {
                rowData: _.cloneDeep(rowData),
                edge: _.cloneDeep(edge),
                directConnectName: directConnectName,
                edgeName: edgeName
        };
        this.isDisconnectGatewayVisible = true;
        this.directConnectName = directConnectName;
    }


    showConnectNetworkDialog(rowData: any, directConnectName: string) {
        this.createData = {'rowData': _.cloneDeep(rowData)};
        this.isConnectNetworkVisible = true;
        this.isEditNetwork = false;
        this.directConnectName = directConnectName;
    }

    connectWizardStatusChange(event) {
        this.isConnectGatewayWizardVisible = event;
        this.isEdit = false;
    }

    editWizardStatusChange(event) {
        this.isEditGatewayWizardVisible = event;
        this.isEdit = false;
    }

    onConnectNetworkClose(event) {
        if (event && event.value) {
            this.isConnectNetworkVisible = false;
            this.isEditNetwork = false;
        }
    }

    onDisconnectGatewayClose(event) {
        if (event && event.value) {
            this.isDisconnectGatewayVisible = false;
        }
    }

    getTitle() {
        return (this.translate.instant('directConnect.directConnect'));
    }

    ngOnDestroy() {
        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/direct-connect-detail.ts